import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';

const SenjaWidget = ({ isMobile }: { isMobile: boolean }) => {
  const urlMap = {
    desktop: {
      src: 'https://widget.senja.io/widget/56a1111c-a9eb-4251-838a-d80b81b3b9f3/platform.js',
      dataId: '56a1111c-a9eb-4251-838a-d80b81b3b9f3',
    },
    mobile: {
      src: 'https://widget.senja.io/widget/fa78fe88-2eb2-402e-993f-b614cdd3ff5e/platform.js',
      dataId: 'fa78fe88-2eb2-402e-993f-b614cdd3ff5e',
    },
  };

  const targetUrl = urlMap[isMobile ? 'mobile' : 'desktop'];

  useEffect(() => {
    const script = document.createElement('script');
    script.src = targetUrl.src;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [isMobile]);

  return (
    <Box sx={{ width: '100%', mt: '60px', mb: '20px' }}>
      <div
        className="senja-embed"
        data-id={targetUrl.dataId}
        data-mode="shadow"
        data-lazyload="false"
        style={{ display: 'block' }}
      ></div>
    </Box>
  );
};

export default SenjaWidget;
